// extracted by mini-css-extract-plugin
export default {"pagination":"webpack-concepts-Guidelines-Pagination-Pagination-module__pagination","currentItems":"webpack-concepts-Guidelines-Pagination-Pagination-module__currentItems"};